/* PrimeCut shared size guide: dialog open/close, inches-first unit toggle and the extra-measurements toggle.
   Used by the tee and pack pages, the collection quick shop and the FAQ. Every opening starts in inches;
   a centimeter choice applies only while that guide stays open. */
(() => {
  'use strict';

  // An earlier version remembered the unit. That stored value must not force centimeters any more.
  try {
    localStorage.removeItem('pcSgUnit');
  } catch (e) {
    /* storage unavailable */
  }

  function applyUnit(root, unit) {
    root.querySelectorAll('[data-pc-unit]').forEach((btn) => btn.setAttribute('aria-pressed', String(btn.dataset.pcUnit === unit)));
    root.querySelectorAll('[data-cm]').forEach((cell) => {
      cell.textContent = unit === 'cm' ? cell.dataset.cm : cell.dataset.in;
    });
  }

  function initGuide(root) {
    if (root.dataset.pcReady) return;
    root.dataset.pcReady = 'true';
    applyUnit(root, 'in');
    root.addEventListener('click', (event) => {
      const unitBtn = event.target.closest('[data-pc-unit]');
      if (unitBtn) {
        applyUnit(root, unitBtn.dataset.pcUnit);
        return;
      }
      const more = event.target.closest('[data-pc-sg-more]');
      if (more) {
        const on = !root.classList.contains('is-more');
        root.classList.toggle('is-more', on);
        more.setAttribute('aria-expanded', String(on));
        more.textContent = on ? more.dataset.lessLabel : more.dataset.moreLabel;
      }
    });
  }

  const openers = new WeakMap();

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else if (dialog.hasAttribute('open')) {
      dialog.removeAttribute('open');
      dialog.dispatchEvent(new Event('close'));
    }
  }

  function initDialog(dialog) {
    if (dialog.dataset.pcDialogReady) return;
    dialog.dataset.pcDialogReady = 'true';
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-pc-sg-close]')) closeDialog(dialog);
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeDialog(dialog);
      }
    });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('pc-scroll-lock');
      const opener = openers.get(dialog);
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    });
  }

  function openDialog(dialog, opener, size) {
    initDialog(dialog);
    const guide = dialog.querySelector('[data-pc-sg]');
    if (guide) {
      initGuide(guide);
      applyUnit(guide, 'in');
    }
    openers.set(dialog, opener || document.activeElement);
    dialog.querySelectorAll('tr[data-size]').forEach((row) => row.classList.toggle('is-active', !!size && row.dataset.size === size));
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    dialog.scrollTop = 0;
    document.documentElement.classList.add('pc-scroll-lock');
    const close = dialog.querySelector('[data-pc-sg-close]');
    if (close) close.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-pc-sg-open]');
    if (!opener) return;
    const dialog = document.getElementById(opener.getAttribute('aria-controls'));
    if (!dialog) return;
    event.preventDefault();
    openDialog(dialog, opener, opener.dataset.pcSgSize || '');
  });

  const init = (scope) => {
    scope.querySelectorAll('[data-pc-sg]').forEach(initGuide);
    scope.querySelectorAll('dialog[data-pc-sg-dialog]').forEach(initDialog);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // Reset an inline guide (quick-add sheet) to inches, collapsed extras and the shopper's current size.
  function resetGuide(scope, size) {
    const guide = scope && (scope.matches && scope.matches('[data-pc-sg]') ? scope : scope.querySelector('[data-pc-sg]'));
    if (!guide) return;
    initGuide(guide);
    applyUnit(guide, 'in');
    guide.classList.remove('is-more');
    const more = guide.querySelector('[data-pc-sg-more]');
    if (more) {
      more.setAttribute('aria-expanded', 'false');
      more.textContent = more.dataset.moreLabel;
    }
    guide.querySelectorAll('tr[data-size]').forEach((row) => row.classList.toggle('is-active', !!size && row.dataset.size === size));
  }

  window.PrimeCutSizeGuide = { open: openDialog, close: closeDialog, reset: resetGuide };
})();
